import { getFirestore } from 'firebase/firestore';

export default function useFirestore() {
  return getFirestore();
}
